// src/components/TugOfWarVisual.js
import React from 'react';

// 1. Impor gambar adegan dari folder aset lokal.
import sceneImage from '../assets/scene-tarik-tambang.png';

// --- Konfigurasi Visual ---
// Tentukan seberapa jauh gambar akan bergeser (dalam persentase) saat salah satu pemain menang.
const MAX_TRANSLATE_PERCENT = 30; 

/**
 * Komponen TugOfWarVisual menampilkan adegan permainan tarik tambang.
 * Posisinya dikontrol oleh satu prop, `ropePosition`.
 * @param {object} props
 * @param {number} props.ropePosition - Nilai numerik yang merepresentasikan posisi tali.
 *   - `0`    = Posisi tengah (awal).
 *   - `-50`  = Pemain kiri menang sepenuhnya.
 *   - `+50`  = Pemain kanan menang sepenuhnya.
 */
function TugOfWarVisual({ ropePosition }) {
    
    // 2. Hitung persentase pergeseran horizontal (translateX).
    // Kita memetakan rentang `ropePosition` (-50 hingga +50) ke rentang pergeseran
    // (`-MAX_TRANSLATE_PERCENT` hingga `+MAX_TRANSLATE_PERCENT`).
    const translateXPercent = (ropePosition / 50) * MAX_TRANSLATE_PERCENT;

    return (
        <div className="game-field">
            <div
                className="tug-of-war-scene"
                // 3. Terapkan pergeseran menggunakan properti `style` di JSX.
                // Menggunakan `transform` lebih efisien untuk animasi daripada mengubah `left` atau `margin`.
                style={{ transform: `translateX(${translateXPercent}%)` }}
            >
                <img 
                    src={sceneImage} 
                    alt="Pemain Tarik Tambang" 
                />
            </div>
            
            {/* Garis tengah tetap statis */}
            <div className="center-line"></div>
        </div>
    );
}

export default TugOfWarVisual;